module.exports = "<fuse-main></fuse-main>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main